<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório Anual de Produção (MAPA Anexo III)
    </div>

    <v-card>
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3">
            <v-autocomplete v-model="periodFilterModel" label="Período" :items="periodFilterOptions" item-value="key"
              item-text="name" />
          </v-col>
          <v-col cols="12" md="4" v-if="periodFilterModel == 'OTHER'">
            <DateRangeField :inputData.sync="periodFilterRangeModel" label="Período Customizado" :hasTodayDate="false" />
          </v-col>

          <v-col cols="6" md="2">
            <v-btn class="mt-3" @click="runFilter(false)">
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="ma-2" outlined @click="downloadAsPDF" v-if="seedlingYearProductionReport && seedlingYearProductionReport.file">
              Download XLS
            </v-btn>

          </v-col>

        </v-row>
      </v-card-text>
    </v-card>



  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      loading: false,
      loadingFilters: false,
      pageLoading: false,
      xlsSource: null,
      monthFilter: moment().format('YYYY-MM'),
      cultureIds: [],
      subCultureIds: [],
      varietyIds: [],
      seedlingYearProductionReport: null,
      startDate: null,
      endDate: null,
      filtersList: null,
      tableHeaders: [
        { text: "Variedade", align: "left", sortable: false, value: "varietyFullName" },
        { text: "Qtd. Plantada", align: "left", sortable: false, value: "plantingTotal" },
        { text: "Qtd. Perda", align: "left", sortable: false, value: "lossTotal" },
        { text: "Saldo", align: "left", sortable: false, value: "resultTotal" },
      ],
      maskFields: [
        { field: 'plantingTotal', mask: 'number' },
        { field: 'lossTotal', mask: 'number' },
        { field: 'resultTotal', mask: 'number' },
      ],
      periodFilterOptions: [
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: "OTHER",
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    // this.loadServerFilters();
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    downloadAsPDF: function(){
      var base64String = this.seedlingYearProductionReport.file;
      // console.log("base64", base64String, ' size ', base64String.length);

      const downloadLink = document.createElement("a");

      // var bytes = new Uint8Array(base64String);
      // var nstring = unescape(encodeURIComponent(base64String));

      // var decodedString = Buffer.from(nstring, 'base64');
      // var blob = new Blob([decodedString], { type: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      // var blob = new Blob([decodedString], { type: "data:application/octet-stream;charset=utf-8" });
      // console.log("decoded", decodedString);
      downloadLink.href = "data:application/octet-stream;base64,"+base64String;
      // downloadLink.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"+decodedString;
      // var file = new File([blob], 'Sample.xls');
      // downloadLink.href = URL.createObjectURL(blob);
      // downloadLink.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+encodeURIComponent(base64String);

      downloadLink.download = "file.xls";

      downloadLink.click();
    },
    loadServerEntries: function (firstLoading = false) {
      this.loading = true;
      console.log("filter model", this.periodFilterRangeModel);
      this.$apollo
        .query({
          query: LOAD_SEEDLING_PLANTING_MAPA_QUERY,
          variables: {
            startDate: this.periodFilterRangeModel[0],
            endDate: this.periodFilterRangeModel[1]
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.seedlingYearProductionReport = response.data.accountContext.seedlingYearProductionReport;
          console.log("sr", this.seedlingYearProductionReport);
          // console.log("this.seedlingYearProductionReport", this.seedlingYearProductionReport);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    runFilter: function (firstLoading = false) {

      this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
      this.endDate = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
      this.loadServerEntries(firstLoading);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },

  }
};

const LOAD_SEEDLING_PLANTING_MAPA_QUERY = gql`
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  accountContext {
    seedlingYearProductionReport(startDate: $startDate, endDate: $endDate) 
  }
}
`;

</script>

<style scoped></style>
